/* One white card centred on the soft blue-grey surface, with a primary accent bar along its
   top edge and the brand mark (ADR 0028). Phones: the card fills the width. */
.page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: var(--space-7) var(--space-4);
  background: var(--canvas);
}

.column {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  width: 100%;
  max-width: 440px;
  padding: var(--space-6);
  border: var(--card-border);
  border-top: 4px solid var(--brand);
  border-radius: var(--radius-card);
  background: var(--paper);
  box-shadow: var(--shadow-card);
}

/* The app name with the same monogram as the sidebar: a white W on primary blue. The letter
   is generated content with empty alternative text, so screen readers hear "Wodi" once. */
.brand {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  color: var(--ink);
  font: var(--t-heading);
  font-weight: 600;
}

.brand::before {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-control);
  background: var(--brand);
  color: var(--on-brand);
  font: var(--t-heading);
  font-weight: 600;
  content: 'W' / '';
}

@media (width < 640px) {
  .page {
    align-items: flex-start;
    padding: var(--space-5) var(--space-4);
  }

  .column {
    padding: var(--space-5);
  }
}

.title {
  font: var(--t-display);
}

.lead {
  color: var(--graphite);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--space-3);
}

.steps {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding-left: var(--space-5);
}

.qr {
  display: block;
  width: 200px;
  height: 200px;
  image-rendering: pixelated;
}

.secret {
  display: block;
  margin-top: var(--space-2);
  font-family: var(--font-id);
  font-size: 15px;
  letter-spacing: 0.08em;
  word-break: break-all;
}

.codes {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-2) var(--space-5);
  margin: 0;
  padding: var(--space-4);
  border: 1px solid var(--rule);
  border-radius: var(--radius-control);
  font-family: var(--font-id);
  list-style: none;
}
